import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface StockFiltersProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
}

export const StockFilters = ({
  searchQuery,
  setSearchQuery,
  selectedCategory,
  setSelectedCategory,
}: StockFiltersProps) => {
  return (
    <div className="flex gap-4 flex-1 min-w-[280px] relative">
      <Input
        placeholder="Rechercher un article par nom..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="max-w-xs pl-8"
      />
      <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
    </div>
  );
};